import React, { useContext, useState } from "react";
import { UserContext } from "context/user";
import { MapActions, MapContext } from "context/map";
import { X } from "phosphor-react";
import cx from "classnames";
import ReactTooltip from "react-tooltip";
import InputField from "components/Input";
import Button from "components/Button";
import "./index.scss";

const encodeObject = (object) => {
  return encodeURIComponent(JSON.stringify(object))
    .replace(/'/g, "%27")
    .replace(/"/g, "%22");
};

const ZoneFields = () => {
  const { profile } = useContext(UserContext);
  const { state, dispatch } = useContext(MapContext);
  const { fields, selectedFields } = state;
  const [searchName, setSearchName] = useState("");

  const toggleField = (id) => {
    const multiSelectEnabled = profile.feature_flags.find(
      (item) =>
        item.feature_flag === "field:multi_select" && item.enabled === true
    );

    dispatch({
      type: MapActions.SET_SELECTED_FIELDS,
      value: { fieldId: id, multiSelectEnabled },
    });
  };

  const mapUrl = (field) => {
    const baseUrl =
      "https://api.mapbox.com/styles/v1/mapbox/satellite-v9/static";
    const geojson = {
      type: "Feature",
      properties: {
        stroke: "#09BA51",
        "stroke-width": 2,
        "stroke-opacity": 1.0,
      },
      geometry: field.geometry,
    };
    const bBox = field.bbox;
    const mapStyle = "100x100@2x?padding=8";
    const mapboxToken = process.env.REACT_APP_MAPGL_ACCESS_TOKEN;

    return `${baseUrl}/geojson(${encodeObject(
      geojson
    )})/[${bBox}]/${mapStyle}&access_token=${mapboxToken}`;
  };

  const renderZoningHeader = () => {
    return (
      <section className="selection-title">
        <h1 className="title">Zoning</h1>
        <InputField
          placeholder="Search for field name..."
          type="text"
          id="field-name"
          className="search-field"
          value={searchName}
          onChange={(e) => setSearchName(e.target.value)}
        />
        <button
          className="close-button"
          type="button"
          onClick={() =>
            dispatch({
              type: MapActions.SET_VIEW_MODE,
            })
          }
        >
          <X size={20} color="#292b33" weight="bold" />
        </button>
      </section>
    );
  };

  const renderFields = () => {
    return (
      <>
        <ReactTooltip className="tooltip" effect="solid" />
        <section className="fields-list">
          {fields
            .filter((item) =>
              item.properties.field_name
                .toLowerCase()
                .includes(searchName.toLocaleLowerCase())
            )
            .map((field) => (
              <div
                className={cx(
                  "field-item",
                  selectedFields.includes(field.id) ? "-selected" : "",
                  field.properties.area > 800 ? "-disabled" : ""
                )}
                key={field.id}
                onClick={() => toggleField(field.id)}
                aria-hidden
              >
                <img className="image" src={mapUrl(field)} alt="field map" />
                <div className="field-details">
                  <div className="primary">
                    <p className="name">{field.properties.field_name}</p>
                    {field.properties.area > 800 ? (
                      <p
                        className="zone-warning"
                        data-tip="Area must be below 800Ha to zone this field."
                      >
                        Zone area exceeded
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="properties">
                    <p className="crop-type">
                      {field.properties.field_crop_type || "Others"}
                    </p>
                    ·<p className="hectares">{field.properties.area} Ha</p>
                  </div>
                </div>
              </div>
            ))}
        </section>
      </>
    );
  };

  const renderActions = () => {
    return (
      <div className="page-action">
        <Button
          type="solid"
          label="Start Zoning"
          color="green"
          block
          disabled={!selectedFields.length}
          onClick={() =>
            dispatch({
              type: MapActions.SET_START_ZONING,
            })
          }
        />
      </div>
    );
  };

  return (
    <div className="zoning-selection">
      {renderZoningHeader()}
      {renderFields()}
      {renderActions()}
    </div>
  );
};

export default ZoneFields;
